import React, { useEffect, useRef, useState } from "react";
import {
  Wrapper,
  ContentWrppper,
  Title,
  SubTitle,
  MoreOptionWrapper,
} from "./index.styled";
import { ReactComponent as TripleDotMoreOptions } from "../../Assets/Icons/TripleDotMoreOptions.svg";
import OptionsList from "../OptionsList";
import Info from "../Info";
import AnimatedCounter from "./AnimatedCounter";

const options = [
  { value: "CoC Accredited", label: "CoC Accredited" },
  { value: "High Revenue ( >$50M )", label: "High Revenue ( >$50M )" },
  { value: "Research Hospitals", label: "Research Hospitals" },
  { value: "Medical Schools", label: "Medical Schools" },
  { value: "Nursing Schools", label: "Nursing Schools" },
  { value: "High Patient Density", label: "High Patient Density" },
];
const QuickFilters = ({
  filterId,

  title,
  subTitle,
  color,
  list,
  right,
  showFilters = false,
  options,
  onFilterChange,
  onClick,
  isSelected = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(options[0]); // Default selection
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (selectedOption) => {
    onFilterChange?.(filterId, selectedOption);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleWrapperClick = () => {
    if (!showFilters) {
      // Only trigger click when not in edit mode
      onClick?.(filterId);
    }
  };
  
  return (
    <Wrapper
      ref={dropdownRef}
      onClick={handleWrapperClick}
      $isClickable={!showFilters}
      $isSelected={isSelected}
    >
      <ContentWrppper>
        <Title>{title}</Title>
        <AnimatedCounter color={color} target={subTitle} />
      </ContentWrppper>
      {showFilters ? (
        <MoreOptionWrapper onClick={toggleDropdown} isOpen={isOpen}>
          <Info
            showArrow={false}
            config={{
              tooltipText: "Options",
              position: "top",
            }}
          >
            <TripleDotMoreOptions />
          </Info>
        </MoreOptionWrapper>
      ) : (
        <></>
      )}
      {/* {isOpen && ( */}
      <OptionsList
        options={options}
        onOptionClick={handleOptionClick}
        customWidth={15.75}
        right={right}
        isOpen={isOpen} // Pass the state
      />
      {/* )} */}
    </Wrapper>
  );
};

export default QuickFilters;
